import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

function RedBookPage() {
  const [pageIndex, setPageIndex] = useState(0);
  const navigate = useNavigate();

  const showcaseImages = [
    "sq5.webp",
    "ver1.webp",
    "ver2.webp",
    "ver3.webp",
    "ver4.webp",
    "ver6.webp",
    "ver7.webp",
    "hor9.webp",
    "hor10.webp",
    "hor11.webp",
    "hor12.webp",
    "hor13.webp",
    "hor14.webp",
    "hor15.webp",
    "hor16.webp",
    "hor17.webp",
    "hor18.webp",
    "hor19.webp",
    "hor20.webp",
    "hor21.webp",
    "hor22.webp",
    "hor23.webp",
    "hor24.webp",
    "hor25.webp",
    "hor26.webp",
    "hor27.webp",
    "hor28.webp",
    "hor29.webp",
    "hor30.webp",
  ];

  // ───────────── PAGE SPLITTING ─────────────
  const firstPage = showcaseImages.slice(0, 7); // sq + vertical images
  const remaining = showcaseImages.slice(8); // horizontal only
  const perPage = 4;

  const pages = [
    firstPage,
    ...Array.from(
      { length: Math.ceil(remaining.length / perPage) },
      (_, i) => remaining.slice(i * perPage, (i + 1) * perPage)
    ),
  ];

  // ───────────── NAVIGATION ─────────────
  const handleNextPage = () => {
    if (pageIndex < pages.length - 1) setPageIndex(pageIndex + 1);
  };

  const handlePrevPage = () => {
    if (pageIndex > 0) setPageIndex(pageIndex - 1);
  };

  const currentPage = pages[pageIndex];

  // ───────────── IMAGE HELPERS ─────────────
  const isHorizontal = (name) => name.includes("hor");

  const half = Math.ceil(currentPage.length / 2);
  const leftImages = currentPage.slice(0, half);
  const rightImages = currentPage.slice(half);

  const renderImages = (list) =>
    list.map((img, idx) => {
      const colSpan = isHorizontal(img) ? "col-span-2" : "col-span-1";

      return (
        <img
          key={idx}
          src={`/showcase/${img}`}
          alt={img}
          className={`${colSpan} w-4/5 h-auto object-contain rounded-md`}
        />
      );
    });

  // ───────────── UI ─────────────
  return (
    <div className="w-full overflow-x-auto bg-gradient-to-b from-[#131b33] to-black">
      <div className="flex justify-center items-center w-full min-h-screen">
        <div
          className="
            relative
            aspect-[16/10]
            w-full
            max-w-[1080px]
            min-w-[250px]
          "
        >
          {/* Background Images */}
          <img src="/books/coverbook_red.webp" className="absolute inset-0 object-cover z-0" />
          <img src="/books/postcard.webp" className="absolute inset-0 object-cover w-6/12 z-10 -top-2" />

          <img
            src="/books/home_icon.webp"
            alt="home icon"
            className="absolute z-[70] mt-[10%] left-[2%] w-[3%] cursor-pointer"
            onClick={() => navigate("/")}
          />
          
          <img src="/books/bottom.webp" className="absolute inset-0 object-cover z-10 pointer-events-none" />
          <img src="/books/middle.webp" className="absolute inset-0 object-cover z-20 pointer-events-none" />
          <img src="/books/above.webp" className="absolute inset-0 object-cover z-30 pointer-events-none" />

          {/* IMAGE SPREAD */}
          <div className="absolute top-[10%] z-[60] px-[10%] flex gap-[10%]">

            {/* LEFT PAGE */}
            <div className="w-[45%] grid grid-cols-2 gap-4">
              {renderImages(leftImages)}
            </div>

            {/* RIGHT PAGE */}
            <div className="w-[45%] grid grid-cols-2 gap-4">
              {renderImages(rightImages)}
            </div>

          </div>

          {/* PAGE NAVIGATION */}
          <motion.button
            className="absolute top-[75%] left-[10%] z-[60] p-2 rounded-full hover:bg-white"
            onClick={handlePrevPage}
            disabled={pageIndex === 0}
            whileHover={{ scale: 1.1 }}
          >
            <ArrowLeftIcon className="w-2 h-2 md:w-6 md:h-6" />
          </motion.button>

          <motion.button
            className="absolute top-[75%] right-[12%] z-[60] p-2 rounded-full hover:bg-white"
            onClick={handleNextPage}
            disabled={pageIndex === pages.length - 1}
            whileHover={{ scale: 1.1 }}
          >
            <ArrowRightIcon className="w-2 h-2 md:w-6 md:h-6" />
          </motion.button>

        </div>
      </div>
    </div>
  );
}

export default RedBookPage;
